import { render } from "./Eva Pharma.vue?vue&type=template&id=2171da20&scoped=true"
const script = {}

import "./Eva Pharma.vue?vue&type=style&index=0&id=2171da20&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2171da20"

export default script